import { render, staticRenderFns } from "./FbpComponentsAndSettings.vue?vue&type=template&id=60203cc3&scoped=true"
import script from "./FbpComponentsAndSettings.vue?vue&type=script&lang=js"
export * from "./FbpComponentsAndSettings.vue?vue&type=script&lang=js"
import style0 from "./FbpComponentsAndSettings.vue?vue&type=style&index=0&id=60203cc3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60203cc3",
  null
  
)

export default component.exports